var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-item-status"},[(_vm.resource['status'])?_c('span',{class:['label', _vm.klass]},[_vm._v(" "+_vm._s(_vm.resource['status'])+" ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }